import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import * as REST from '~services/rest';
import { searchCriteria } from '~containers/workers/list/searchCriteria';

import { useGet } from '~hooks/useQuery';
import useColdShowcaseRefresh from '~hooks/useColdShowcaseRefresh';
import { isVerified, stringToJSON } from '~helpers/common';

import Carousel from '~components/carousel';
import Button from '~components/button';
import CarouselSkeleton from '~components/carousel/skeleton';
import { LocationSearch } from '~components/forms/location';
import { useHistory } from 'react-router-dom';
import ServerContext from '~src/serverContext';
import { AuthContext } from '~contexts/auth';

import { Suspense, ErrorBoundary } from '~components/suspense';
import { useIntl } from 'react-intl';

import WorkerCard from '~components/card/worker';
import { getWorkersCount } from '~containers/intake/client/utils';
import { DEFAULT_PRICE } from '~constants/index.js';

// import CTA from './cta';

const List = () => {
  const intl = useIntl();
  const cache = useContext(ServerContext);
  const { isAuthenticated } = useContext(AuthContext);
  const history = useHistory();

  const { data, isLoading, fetch: refreshWorkers } = useGet(
    {
      name: `workers`,
      params: {
        domain: true,
      },
      cacheData: cache.get('serverHomepageWorkers')?.data?.length ? cache.get('serverHomepageWorkers') : null,
      mockFileName: 'workers/get-workers-by-domain',
    },
    []
  );

  useColdShowcaseRefresh(data, isLoading, refreshWorkers);

  // const handleLocationChange = (location) => {
  //   if (location && location.place_id) {
  //     history.push({
  //       pathname: '/workers',
  //       search: `?locationId=${location.place_id}`,
  //       state: {
  //         location: {
  //           locationId: location.place_id,
  //           address: location.address,
  //         },
  //       },
  //     });
  //   }
  // };

  // const handleLocationChange = async (location) => {
  //   console.log('location', location);
  //   if (!location?.place_id) return;
  
  //   try {
  //     const locationResponse = await REST.get({
  //       name: 'locations',
  //       mockFileName: 'locations/get-by-id',
  //       params: { 'place-id': location.place_id },
  //     });
  
  //     const first = locationResponse?.data?.[0];
  //     const locData = first?.location;
  //     const priceData = first?.pricing;
  
  //     // Build locationDetails in the same shape as useLocationDetails
  //     const locationDetails = locData
  //       ? { ...locData, locationId: locData.place_id, address: locData.address }
  //       : null;
  
  //     const pricingDetails =
  //       priceData?.currency != null &&
  //       priceData?.min_price != null &&
  //       priceData?.max_price != null
  //         ? {
  //             currency: priceData.currency,
  //             minPrice: priceData.min_price,
  //             maxPrice: priceData.max_price,
  //           }
  //         : DEFAULT_PRICE;
  
  //     // If we still don't have a usable location, just go to list
  //     if (!locationDetails || locationDetails.latitude == null || locationDetails.longitude == null) {
  //       history.push({
  //         pathname: '/workers',
  //         search: `?locationId=${location.place_id}`,
  //         state: {
  //           location: {
  //             locationId: location.place_id,
  //             address: location.address,
  //           },
  //         },
  //       });
  //       return;
  //     }
  
  //     // Use SAME worker-count logic as banner
  //     const resultsCount = await getWorkersCount(locationDetails, pricingDetails, {});
  
  //     // IMPORTANT: treat 0 OR null as "no workers"
  //     if (!resultsCount) {
  //       history.replace(`/intake/client?locationId=${location.place_id}`);
  //       return;
  //     }
  
  //     // At least one worker → list page
  //     history.push({
  //       pathname: '/workers',
  //       search: `?locationId=${location.place_id}`,
  //       state: {
  //         location: {
  //           locationId: location.place_id,
  //           address: location.address,
  //         },
  //       },
  //     });
  //   } catch (e) {
  //     // On error, still show the list
  //     history.push({
  //       pathname: '/workers',
  //       search: `?locationId=${location.place_id}`,
  //       state: {
  //         location: {
  //           locationId: location.place_id,
  //           address: location.address,
  //         },
  //       },
  //     });
  //   }
  // };

  if (!isLoading && !data?.data?.length) return null;

  return (
    <>

      <div className="c-wc">
        <div className="c-wc__subtitle">
          {intl.formatMessage({
            id: 'containers.homepage.seo.list.subtitle',
            defaultMessage: 'Looking for a cleaner?',
          })}
        </div>
        <div className="c-wc__title">
          {intl.formatMessage({
            id: 'containers.homepage.seo.list.title',
            defaultMessage: 'Here are some!',
          })}
        </div>
      </div>
      <Suspense fallback={<CarouselSkeleton skeletonCount={4} />} isLoading={isLoading}>
        <ErrorBoundary fallback={<h2 className="l-error">Could not load cleaners data</h2>}>
          <Carousel className="c-homepage-workers" ariaLabel={intl.formatMessage({ id: 'containers.homepage.seo.list.title', defaultMessage: 'Here are some cleaners' })}>
            {data &&
              data.data &&
              data.data
                .slice(0, 4)
                .map((worker, index) => (
                  <WorkerCard
                    key={worker.id}
                    personId={worker.id}
                    score={worker.score}
                    price={worker.price}
                    address={worker.location}
                    experience={worker.experience}
                    firstName={worker.first_name}
                    profilePicture={stringToJSON(worker.profile_picture)}
                    verification={isVerified(worker.verification)}
                    lastLogin={worker.last_login}
                    registerDate={worker.registered_date}
                    isOnline={worker.is_online}
                    personalNote={worker.personal_note}
                    published={worker.published} 
                    slug={worker.slug}
                    isHomePage={true}
                  />
                ))}
          </Carousel>
        </ErrorBoundary>
      </Suspense>
      {/* <div className="c-wc__button-wrapper">
        <Link to="/intake/client" rel="nofollow">
          <Button className="c-btn--text large">
            {intl.formatMessage({
              id: 'containers.homepage.list.button',
              defaultMessage: 'Find your help!',
            })}
          </Button>
        </Link>
      </div> */}

      {/* <div className="c-action__wrapper">
        <div className="c-form-section c-form-section--center">
          <LocationSearch
            placeholder={intl.formatMessage({
              id: 'containers.wishes.form.fields.address.placeholder',
              defaultMessage: 'Address',
            })}
            onSubmit={handleLocationChange}
            className="c-autocomplete--focus-disabled"
          />
        </div>

        <div className="c-header-buttons">
          {!isAuthenticated ? (
            <Link to="/intake/worker">
              <Button className="c-btn--text">
                {intl.formatMessage({
                  id: 'containers.homepage.seo.hero.buttons.clients',
                  defaultMessage: "I'm looking for a client",
                })}
              </Button>
            </Link>
          ) : (
            <Link to="/listings">
              <Button className="c-btn--text">
                {intl.formatMessage({
                  id: 'containers.homepage.hero.buttons.overview',
                  defaultMessage: 'Go to overview',
                })}
              </Button>
            </Link>
          )}
        </div>

      </div> */}

{/* <CTA /> */}

    </>
  );
};

export default List;
